import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';

@Injectable()
export class WeekService {

  constructor(private http:Http) {

  }

  getWeek(weekid):Promise<string>{
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_WEEK + "/" + weekid;
    return this.http.get(url).toPromise().then(res => res.json());
  }

}
